import React, { FC } from 'react';
import classNames from 'classnames';

import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Overlay from '@sv-support-sdk/ui-components/src/components/Layout/Overlay';

import Modal from '../../../components/Layout/Modal';
import Link from '../../Controls/Link';
import Button from '../../Controls/Button';

import { useAppDispatch } from '../../../store/hooks';
import modalActions from '../../../store/actions/modals';
import { THANK_YOU_MODAL } from '../../../constants/modals';
import { $l } from '../../../locales';
import { routes } from '../../../routing';
import useMobileDetect from '../../../hooks/useMobileDetect';

import css from './style.module.scss';
import {
  SUPPORT_THANK_YOU_MODAL,
  SUPPORT_THANK_YOU_MODAL_CLOSE,
  SUPPORT_THANK_YOU_MODAL_TICKET_LINK,
  SUPPORT_THANK_YOU_MODAL_TICKETS_LIST_LINK,
} from '../../../constants/qaAttributes';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  ticketId: number;
}

const ThankYouModal: FC<IProps> = ({ ticketId }) => {
  const dispatch = useAppDispatch();
  const isMobile = useMobileDetect();

  const closeModal = () => {
    dispatch(modalActions.closeModal(THANK_YOU_MODAL));
  };

  return (
    <Overlay align="center" zIndex="1501">
      <Modal
        type={isMobile ? 'mobile' : undefined}
        title={$l('THANK_YOU_MODAL.TITLE')}
        onCloseClick={closeModal}
        qaId={SUPPORT_THANK_YOU_MODAL}
      >
        <div
          className={classNames(css.modal__description, {
            ['indent-xxl-top']: isMobile,
          })}
        >
          {$l('THANK_YOU_MODAL.CONTACT_YOU')}
          <br />
          {$l('THANK_YOU_MODAL.CHECK_SPAM')}
        </div>
        <div className={css.modal__details}>
          <div className={css.modal__details__info}>
            {$l('THANK_YOU_MODAL.YOUR_TICKET')}{' '}
            <Link
              className={css.modal__details__link}
              onClick={closeModal}
              textDecoration="none"
              to={`${routes.tickets}/${ticketId}`}
              {...setQaAttribute(SUPPORT_THANK_YOU_MODAL_TICKET_LINK)}
            >
              #{ticketId}
            </Link>
          </div>
          <div className={css.modal__details__info}>
            {$l('THANK_YOU_MODAL.TRACK_YOUR_STATUS')}{' '}
            <Link
              onClick={closeModal}
              className={css.modal__details__link}
              textDecoration="none"
              to={routes.tickets}
              {...setQaAttribute(SUPPORT_THANK_YOU_MODAL_TICKETS_LIST_LINK)}
            >
              {$l('THANK_YOU_MODAL.SUPPORT_HISTORY_PAGE')}
            </Link>
          </div>
        </div>
        <Actions flex="1" align="end" width="full" className="indent-md-bottom">
          <ActionsItem
            width={isMobile ? 'full' : undefined}
            className={classNames({
              ['indent-sm-right']: !isMobile,
            })}
          >
            <Button
              padding="0-26"
              width={isMobile ? undefined : 'auto'}
              onClick={() => dispatch(modalActions.closeModal(THANK_YOU_MODAL))}
              text={$l('THANK_YOU_MODAL.CLOSE_BUTTON')}
              {...setQaAttribute(SUPPORT_THANK_YOU_MODAL_CLOSE)}
            />
          </ActionsItem>
        </Actions>
      </Modal>
    </Overlay>
  );
};

export default ThankYouModal;
